import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.number}>
            <div className="flex flex-col items-center flex-1">
              <div
                className={cn(
                  "w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-300",
                  currentStep === step?.number
                    ? "bg-primary border-primary text-primary-foreground"
                    : currentStep > step?.number
                    ? "bg-success border-success text-success-foreground"
                    : "bg-background border-border text-muted-foreground"
                )}
              >
                {currentStep > step?.number ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <Icon name={step?.icon} size={20} />
                )}
              </div>
              <div className="mt-2 text-center">
                <p
                  className={cn(
                    "text-sm font-medium transition-colors",
                    currentStep >= step?.number
                      ? "text-foreground"
                      : "text-muted-foreground"
                  )}
                >
                  {step?.title}
                </p>
                <p className="text-xs text-muted-foreground mt-1">Step {step?.number}</p>
              </div>
            </div>

            {index < steps?.length - 1 && (
              <div
                className={cn(
                  "flex-1 h-0.5 mx-2 transition-colors duration-300 mt-[-40px]",
                  currentStep > step?.number
                    ? "bg-success" :"bg-border"
                )}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
